
    const instance = {};
    
    // country specific params
    instance.active_country = 'RO';
    instance.active_language = 'ro';
    instance.national_phone_format = "07xxxxxxxx";
    instance.msisdn_phone_format = "407xxxxxxxx";
    instance.country_prefix_format = "RO";
    instance.tracking_default_lpc = "LPCfkROO123";
    instance.available_languages = ['ro',];
    // product specific params
    instance.portal_name = "Workinfit";
    instance.product_name = "Workinfit";
    instance.product_dns = "workinfit.com";
    instance.landing_url = "https://subscribe.workinfit.com/launch/";
    instance.landing_code = "WF";
    
    instance.thumbsItem = [	
        { thumb: require('@/assets/images/thumbs/thumb-01.jpg'), title: 'Heel Taps'},	
        { thumb: require('@/assets/images/thumbs/thumb-02.jpg'), title: 'Romanian Dead Lift'},	
        { thumb: require('@/assets/images/thumbs/thumb-03.jpg'), title: 'Balance Yoga Workout'},	
        { thumb: require('@/assets/images/thumbs/thumb-04.jpg'), title: 'Ideal Practices For Mornings'},	
        { thumb: require('@/assets/images/thumbs/thumb-05.jpg'), title: 'Yoga Practices'},	
        { thumb: require('@/assets/images/thumbs/thumb-06.jpg'), title: 'Doing Workout With A Rope'},	
        { thumb: require('@/assets/images/thumbs/thumb-07.jpg'), title: 'Try Yoga To Lose Weight'},	
        { thumb: require('@/assets/images/thumbs/thumb-08.jpg'), title: 'How To Have Artistic Body'},	
        { thumb: require('@/assets/images/thumbs/thumb-09.jpg'), title: 'Jump Squats'},	

    ];
    instance.logo_image_file = require('@/assets/images/landings/portal-logo-workinfit.png');	
    instance.landing_fallback = '';	

    // country and product specific params
    instance.sms_info = {
        'sc': '1234',
        'kw': 'PASS',
    }
    
    // landing specific params
    instance.landing_name_array = "Inspire_PIN";
    instance.landing_dynamic_type = "";
    
    // source specific params
    instance.gtm_array = "GTM-KLTJCKKS";
    instance.tracking_aff = "AFFd3fAu1t0";
    instance.tracking_src = "991PROVSUB992";
    instance.tracking_google_lpc = "NA";
    
    // API urls
    instance.api_PhoneNumber = 'https://api.rvdhub.com/landing/providePhoneNumberV2';
    instance.api_PhoneNumber_v3= 'https://api.rvdhub.com/landing/providePhoneNumberV3';
    instance.api_PhoneNumber_v4 = 'https://api.rvdhub.com/landing/providePhoneNumberV4'; // test goal
    instance.api_ValidatePin = 'https://api.rvdhub.com/landing/validatePinCodeV2';
    instance.api_ClickFlowSaveSession = 'https://api.rvdhub.com/landing/clickFlowSaveSession';
    instance.api_ClickFlowTreatPayment = 'https://api.rvdhub.com/landing/clickFlowTreatPayment';

    instance.api_SendAccessCodeByEmail = 'https://api.rvdhub.com/landing/sendAccessCodeByEmail';
    instance.api_checkNewSubscription = 'https://api.rvdhub.com/landing/checkNewSubscription';
    instance.api_checkNewSubscription_v2 = 'https://api.rvdhub.com/landing/checkNewSubscriptionV2';
    instance.api_checkIfSubscribed = 'https://api.rvdhub.com/landing/checkIfSubscribed';
    instance.api_checkIfProvSubsOk = 'https://api.rvdhub.com/landing/checkIfProvSubsOk';
    
    instance.api_getAntifraudScript = 'https://api.rvdhub.com/landing/getAntifraudScript';
    instance.api_registerVisit = 'https://api.rvdhub.com/landing/registerVisit';

    instance.api_LegalTerms = 'https://api.rvdhub.com/store/getPortalTermsOfService';
    instance.api_LegalPrivacy = 'https://api.rvdhub.com/store/getPortalPrivacyPolicy';
    instance.api_LegalCookiesPolicy = 'https://api.rvdhub.com/store/getPortalCookiesPolicy';
    instance.api_LegalContact = 'https://api.rvdhub.com/store/getPortalContact';

    // tracking api url
    instance.trackingAPI = 'https://notused.com';

    // affiliates CODE
    instance.affiliates_array = {
        "AFFd3fAu1t0": "DF",
        "AFFg00g1e01": "RV",
        "AFFg00g1e77": "DN",
        "AFFg00g1e69": "BN",
        "AFFg00g1e22": "DS"
    };

    export const helpers = instance;
    
    // antifraud step
    instance.antifraud_step = "step2";
    
    // antifraud percentage
    instance.antifraud_percentage = "100";
    
    instance.secret = "launch";
    